import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-grid">
          {/* About Section - Hidden on mobile */}
          <div className="footer-section footer-about">
            <h2 className="footer-title">Nexite</h2>
            <p className="footer-description">
              Nexite IT <br />
              Inhaber: Khashayar Alavi<br />
              Auf dem Schnorrenberg 6<br />
              50354 Hürth<br />
              Tel +49 178 - 86 22 28 2<br />
              E-Mail: info@nexite-it.com
            </p>
            <div className="social-links">
              <a href="https://www.facebook.com/" className="social-icon" target="_blank" rel="noopener noreferrer">
                f
              </a>
              <a href="https://www.linkedin.com/company/nexite-it/" className="social-icon" target="_blank" rel="noopener noreferrer">
                in
              </a>
            </div>
          </div>

          {/* Features Section */}
          <div className="footer-section">
            <h3 className="footer-title">Features</h3>
            <ul className="footer-list">
              {/* <li><Link to="/services/software-development" className="footer-link">Software Entwicklung</Link></li> */}
              <li><Link to="/services/web-development" className="footer-link">Web Entwicklung</Link></li>
              <li><Link to="/services/app-development" className="footer-link">App Entwicklung</Link></li>
              <li><Link to="/services/ui-ux-design" className="footer-link">UI/UX Design</Link></li>
            </ul>
          </div>

          {/* Legal Section */}
          <div className="footer-section">
            <h3 className="footer-title">Rechtlich</h3>
            <ul className="footer-list">
              <li><Link to="/agb" className="footer-link">AGB</Link></li>
              <li><Link to="/impressum" className="footer-link">Impressum</Link></li>
              <li><Link to="/datenschutz" className="footer-link">Datenschutz</Link></li>
            </ul>
          </div>
        </div>

        <div className="copyright-section">
          <p>&copy; {new Date().getFullYear()} Nexite IT. Alle Rechte vorbehalten.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;